<template>
    <div class="add-new-item" >
		<font-awesome-icon class="icon" icon="plus" @click="onClick()"/>
        <span class="title" @click="onClick()">{{ title }}</span>
        <input v-if="isEditMode" ref="dataInput" @keyup.escape="cancel()" @keyup.enter="submit()" type="text" :placeholder="watermark" v-model="data"/>
    </div>
</template>

<script>
export default {
    props: ['title', 'watermark'],
	data: function () {
		return {
			isEditMode: false,
			data: ""
		}
	},
	methods: {
		onClick() {
			if (this.isEditMode) {
				this.cancel();
				return;
			}
			this.isEditMode = true;
			this.$nextTick(() => {
				this.$refs.dataInput.focus()
			});
		},
		cancel() {
			this.isEditMode = false;
			this.data = ""
		},
		submit() {
			const data = this.data;
			this.cancel();
			if (data) {
				this.$emit('submit', data);
			}
		}
	}
}
</script>

<style scoped>

.add-new-item{
	display: grid;
	grid-template-areas:
	"icon title"
	"text text";
	grid-template-columns: auto 1fr;
	grid-template-rows: auto auto;
}
.icon{
	grid-area: icon;
	margin-right: 0.5em;
}
.title {
	grid-area: title;
}

.add-new-item>input {
	grid-area: text;
	height: 2em;
	margin-top: 0.5em;
}
.add-new-item>span:hover {
	cursor: pointer;
}

.add-new-item>a {
	text-decoration: none;
}

</style>

